
import * as React from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import { getPanelsContainer } from '__editor/panelsEditor/components/panels/utils/panelsContainer';

export default class SetArrayTransparent extends React.Component {
  state = { transparentArray: false };

  setArrayTransparent = (value: boolean) => {
    const panelContainer = getPanelsContainer();

    if (value) {
      panelContainer.alpha = 0.3;
    } else {
      panelContainer.alpha = 1;
    }
  }

  render() {
    const panelContainer = getPanelsContainer();
    const { transparentArray } = this.state;
    let shouldBeChecked;

    if (panelContainer) {
      shouldBeChecked = panelContainer.alpha === 0.3 || transparentArray;
    }

    return (
      <FormControlLabel
        className="dsp-array-checkbox"
        control={
          <Checkbox
            id="set-array-transparent"
            name="transparent_array"
            defaultChecked={shouldBeChecked}
            onChange={(event) => this.setArrayTransparent(event.target.checked)}
          />
        }
        label="Set array transparent"
      />
    );
  }
}
